/**
 * quick-260513-bx4 — Project Detail "Engineering Activity" panel client.
 * quick-260513-cc4 — Extended with SparklinePoint type and sparkline field.
 * Backend: GET /api/projects/:projectId/engineering-stats?window=
 */
import { apiGet } from './client';

export type ProjectEngineeringStatsWindow = '7d' | '30d' | '13w';

export interface ProjectEngineeringTotals {
  commits: number;
  additions: number;
  deletions: number;
  filesChanged: number;
  aiPct: number;
}

export interface PerRepoStatsRow {
  repoId: string;
  owner: string;
  name: string;
  commits: number;
  additions: number;
  deletions: number;
  filesChanged: number;
}

export interface TopContributorRow {
  userId: number;
  userName: string;
  commits: number;
  additions: number;
  deletions: number;
  filesChanged: number;
  aiPct: number;
}

export interface SparklinePoint {
  week: number;
  value: number;
}

export interface ProjectEngineeringStats {
  window: ProjectEngineeringStatsWindow;
  totals: ProjectEngineeringTotals;
  perRepo: PerRepoStatsRow[];
  topContributors: TopContributorRow[];
  sparkline: SparklinePoint[];
}

export async function getProjectEngineeringStats(
  projectId: number,
  window: ProjectEngineeringStatsWindow,
): Promise<ProjectEngineeringStats> {
  const res = await apiGet<{ data: ProjectEngineeringStats }>(
    `/projects/${projectId}/engineering-stats?window=${window}`,
  );
  return res.data;
}
